var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32877 10.3289C9.71955 10.1816 10 9.77904 10 9.3055C10 8.70719 9.55228 8.22217 9 8.22217C8.44772 8.22217 8 8.70719 8 9.3055C8 9.77904 8.28045 10.1816 8.67123 10.3289C8.66823 10.3484 8.66667 10.3684 8.66667 10.3888V19.4166C8.66667 19.616 8.81591 19.7777 9 19.7777C9.18409 19.7777 9.33333 19.616 9.33333 19.4166V10.3888C9.33333 10.3684 9.33177 10.3484 9.32877 10.3289ZM10 10.6164C10 10.4773 10.0734 10.351 10.1913 10.2961C10.6106 10.1012 11.6417 9.66661 12.5 9.66661C13.5737 9.66661 14.9176 10.3466 14.9964 10.387C14.9989 10.3883 15.0009 10.3893 15.0035 10.3905C15.0833 10.4288 16.518 11.1111 17.5 11.1111C18.1513 11.1111 19.0016 10.811 19.5238 10.5977C19.7498 10.5054 20 10.6844 20 10.9461V15.9304C20 16.0739 19.9218 16.2036 19.7988 16.257C19.3528 16.4507 18.2604 16.8888 17.5 16.8888C16.556 16.8888 15.1003 16.2136 15.0049 16.1689C15.0015 16.1673 14.9986 16.1659 14.9952 16.1642C14.9055 16.1183 13.5688 15.4444 12.5 15.4444C11.8027 15.4444 10.9914 15.7312 10.4867 15.9434C10.2581 16.0395 10 15.8592 10 15.5935V10.6164Z",
    fill: "#5F6F7C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    stroke: "#5F6F7C",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrograms);
export default __webpack_public_path__ + "static/media/Programs.7dc377eb2d6899286eb82a8c51b831e7.svg";
export { ForwardRef as ReactComponent };